import { render, staticRenderFns } from "./BulkJobHistory.vue?vue&type=template&id=2dede0dc&scoped=true"
import script from "./BulkJobHistory.vue?vue&type=script&lang=ts"
export * from "./BulkJobHistory.vue?vue&type=script&lang=ts"
import style0 from "./BulkJobHistory.vue?vue&type=style&index=0&id=2dede0dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dede0dc",
  null
  
)

export default component.exports